import { Directive, AfterViewInit, OnDestroy } from '@angular/core';
import { ElementRef } from "@angular/core";
import { Subscription } from 'rxjs';
import { AppServices } from 'app/app.services';

@Directive({
  selector: '[trapFocus]'
})

export class TrapfocusDirective implements AfterViewInit, OnDestroy{
  private modal_el: HTMLElement;
  private keyPressSubscription:Subscription;
  private firstFocusableElement:any;
  private focusableContent:any;
  private lastFocusableElement:any;
  private focusableElements = 'button:not([disabled]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
  private arrRadioGrp:any[] = [];

  constructor(private elementRef: ElementRef, private appServices:AppServices) {
    this.modal_el = elementRef.nativeElement;
  }

  ngAfterViewInit() {
    if (!(this.modal_el instanceof HTMLElement)) return;
    this.setElementVar();
    this.createRadioGrp();
    this.keyPressSubscription = this.appServices.keyPressedEvent$.subscribe(event => this.keyPressHandler(event));
    setTimeout(()=>{
      this.firstFocusableElement.focus();
    },500);
  }

  private setElementVar(){
    this.firstFocusableElement = this.modal_el.querySelectorAll(this.focusableElements)[0]; // get first element to be focused inside modal
    this.focusableContent = this.modal_el.querySelectorAll(this.focusableElements);
    this.lastFocusableElement = this.focusableContent[this.focusableContent.length - 1]; // get last element to be focused inside modal
  }

  private createRadioGrp(){
    if((document.activeElement instanceof HTMLInputElement) && (document.activeElement).type == 'radio'){
      const radioname = document.activeElement.getAttribute('name');
      this.arrRadioGrp = Array.from(this.modal_el.querySelectorAll(`input[type=radio][name=${radioname}]`));
    }else{
      this.arrRadioGrp = [];
    }
  }

  private keyPressHandler(e){
    let isTabPressed = e.key === 'Tab' || e.keyCode === 9;
    if (!isTabPressed) {
      return;
    }
    this.setElementVar();
    this.createRadioGrp();
    const indexOfTargetRadio = this.arrRadioGrp.indexOf(e.target);
    if (e.shiftKey) { // if shift key pressed for shift + tab combination
      if (document.activeElement === this.firstFocusableElement) {
        this.lastFocusableElement.focus();
        e.preventDefault();
      }else if(indexOfTargetRadio > 0){
        this.arrRadioGrp[indexOfTargetRadio - 1].focus(); //focus radio element on tab+shift
        e.preventDefault();
      }
    } else { // if tab key is pressed
      if (document.activeElement === this.lastFocusableElement) { 
        this.firstFocusableElement.focus(); 
        e.preventDefault();
      }else if((indexOfTargetRadio >= 0) && (indexOfTargetRadio < (this.arrRadioGrp.length - 1))){
        this.arrRadioGrp[indexOfTargetRadio + 1].focus(); //focus radio element on tab
        e.preventDefault();
      }
    }
  }

  ngOnDestroy(): void {
    if(this.keyPressSubscription)
    this.keyPressSubscription.unsubscribe();
  }
  
}